import { createContext, type Dispatch, type SetStateAction } from 'react'

export type DashboardDrawerState = 'CLOSED' | 'NODE_DETAIL'

export interface DashboardContextValue {
  selectedChecklistNodeId: string | null
  drawerState: DashboardDrawerState
  setSelectedChecklistNodeId: Dispatch<SetStateAction<string | null>>
  openChecklistNode: (nodeId: string) => void
  closeChecklistNode: () => void
}

export const DashboardContext = createContext<DashboardContextValue | undefined>(undefined)
